import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    background: linear-gradient(180deg, #0f172a, #071032);
    border-radius: 12px;
    padding: 10px;
    box-shadow: 0 6px 18px rgba(2, 6, 23, 0.6);
    color: #e6eef8;
    font-family:
        Inter,
        system-ui,
        -apple-system,
        'Segoe UI',
        Roboto,
        'Helvetica Neue',
        Arial;
`;
export const Title = styled.h3`
    margin: 0 0 10px 0;
    font-size: 16px;
    letter-spacing: -0.2px;
`;
export const Row = styled.div`
    display: flex;
    justify-content: right;
    align-items: baseline;
    gap: 12px;
`;
export const NumberText = styled.div`
    font-size: 14px;
    color: #cfe8ff;
`;
export const Small = styled.div`
    font-size: 12px;
    color: #9fb7d9;
`;
export const ProgressWrap = styled.div`
    margin-top: 12px;
`;
export const Bar = styled.div`
    width: 100%;
    height: 12px;
    background: rgba(255, 255, 255, 0.06);
    border-radius: 8px;
    overflow: hidden;
`;
export const Fill = styled.div<{$percent: number}>`
    height: 100%;
    width: ${({$percent}) => $percent}%;
    transition: width 420ms cubic-bezier(0.2, 0.9, 0.3, 1);
    background: linear-gradient(90deg, #3b82f6, #06b6d4);
`;

export const Legend = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
    font-size: 12px;
    color: #9fb7d9;
`;
